module.exports = __webpack_public_path__ + "media/dashboard/assets/images/priority_icons/low-443d2d302e3cebb991b5577a5867350a.svg";